export default ({
  xs: 400,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
})
